import { useMutation, useQueryClient } from "@tanstack/react-query";
import { researchService } from "../services/research.service";
import { UpdateChatPayload } from "../types/research.types";

export const useUpdateChat = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateChatPayload) => researchService.updateChat(payload),
    onSuccess: () => {
      // Invalidate chats query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["chats"] });
    },
  });
};
